import { compose } from 'ramda';
import { filter, map } from 'rxjs/operators';
import { keyBy } from 'lodash';
import { entryAvailable } from '@play/state';

/**
 * Gets the nickname of a player
 *
 * @param player
 */
const getNickname = (player) => player.nickname;
/**
 * Checks if a player has premium or not
 *
 * @param player
 */
const hasPremium = (player) => player.premium;
/**
 * Gets the trustlevel of a player
 *
 * @param player
 */
const getTrustLevel = (player) => player.trustLevel;
/**
 * Checks if a player has trusted or not
 *
 * @param player
 */
const hasTrusted = compose(Boolean, getTrustLevel);
/**
 * Gets the id of a player
 *
 * @param player
 */
const getId = (player) => +player.id;

const playersToDictionary = () => {
    return players$ => players$.pipe(filter(players => players.size && players.every(({ loading }) => !loading) && players.every(entryAvailable)), map(players => players.toArray().map(({ entry }) => entry)), map(players => keyBy(players, "id")));
};

/**
 * Generated bundle index. Do not edit.
 */

export { getId, getNickname, getTrustLevel, hasPremium, hasTrusted, playersToDictionary };
//# sourceMappingURL=play-utility-player.js.map
